// Funnel + product-coach steps for the setup / product guide.

export const STEPS = {
  TERMS: 'terms',
  AUTHORIZE: 'authorize',
  GROUP: 'group',
  MEMBERS: 'members',
  CHECKOUT: 'checkout',
  DASHBOARD: 'dashboard',
  REPORT: 'report',
  OTHER: 'other',
};

export const ONBOARDING_PATHS = {
  '/': STEPS.TERMS,
  '/authorize': STEPS.AUTHORIZE,
  '/subscription': STEPS.GROUP,
  '/subscription2': STEPS.MEMBERS,
  '/checkout': STEPS.CHECKOUT,
  '/dashboard': STEPS.DASHBOARD,
  '/data': STEPS.REPORT,
};

export const STEP_META = {
  [STEPS.TERMS]: {
    label: 'Connect GitLab',
    title: 'Welcome to GitDone',
    checklist: [
      'Read terms',
      'Authorize GitLab',
      'Pick a group',
      'Choose members',
      'Open Overview',
    ],
    checklistIndex: 0,
  },
  [STEPS.AUTHORIZE]: {
    label: 'Syncing account',
    title: 'Connecting your GitLab account',
    checklist: [
      'Read terms',
      'Authorize GitLab',
      'Pick a group',
      'Choose members',
      'Open Overview',
    ],
    checklistIndex: 1,
  },
  [STEPS.GROUP]: {
    label: 'Select group',
    title: 'Choose a GitLab group',
    checklist: [
      'Read terms',
      'Authorize GitLab',
      'Pick a group',
      'Choose members',
      'Open Overview',
    ],
    checklistIndex: 2,
  },
  [STEPS.MEMBERS]: {
    label: 'Select members',
    title: 'Choose team members to track',
    checklist: [
      'Read terms',
      'Authorize GitLab',
      'Pick a group',
      'Choose members',
      'Open Overview',
    ],
    checklistIndex: 3,
  },
  [STEPS.CHECKOUT]: {
    label: 'Activate',
    title: 'Finish activation',
    checklist: [
      'Read terms',
      'Authorize GitLab',
      'Pick a group',
      'Choose members',
      'Open Overview',
    ],
    checklistIndex: 4,
  },
  [STEPS.DASHBOARD]: {
    label: 'Overview',
    title: 'Overview coach',
    checklist: [
      'Scan activity',
      'Open Progress Report',
      'Load a Gantt',
      'Ask about an issue',
    ],
    checklistIndex: 0,
  },
  [STEPS.REPORT]: {
    label: 'Progress Report',
    title: 'Progress Report coach',
    checklist: [
      'Scan activity',
      'Open Progress Report',
      'Load a Gantt',
      'Ask about an issue',
    ],
    checklistIndex: 2,
  },
  [STEPS.OTHER]: {
    label: 'Guide',
    title: 'GitDone guide',
    checklist: [],
    checklistIndex: -1,
  },
};

export const getStepFromPath = (pathname = '/') => {
  if (ONBOARDING_PATHS[pathname]) {
    return ONBOARDING_PATHS[pathname];
  }
  return STEPS.OTHER;
};

export const isOnboardingStep = (step) => {
  return [
    STEPS.TERMS,
    STEPS.AUTHORIZE,
    STEPS.GROUP,
    STEPS.MEMBERS,
    STEPS.CHECKOUT,
  ].includes(step);
};

export const isProductStep = (step) => {
  return step === STEPS.DASHBOARD || step === STEPS.REPORT;
};
